import React from 'react';
import { MockVideo } from '@/hooks/video-generator/useVideoGeneration';
import { VideoDetail } from './VideoDetail';

interface VideoLightboxProps {
  video: MockVideo | null;
  isOpen: boolean;
  onClose: () => void;
  allVideos?: MockVideo[];
  onNavigate?: (video: MockVideo) => void;
}

const VideoLightbox: React.FC<VideoLightboxProps> = ({ 
  video, 
  isOpen, 
  onClose, 
  allVideos = [],
  onNavigate 
}) => {
  return (
    <VideoDetail
      video={video}
      isOpen={isOpen}
      onClose={onClose}
      allVideos={allVideos}
      onNavigate={onNavigate}
      showLikeButton={true}
      showDescription={true}
    />
  );
};

export default VideoLightbox; 